var moduleCollapse = {
	init: function() {

        $('body')
			.on('click', '.js-collapse .dkt-collapse_header', function(){
				var allCollapse = document.getElementsByClassName('dkt-collapse');
				var thisBody = this.parentNode.querySelector('.dkt-collapse_body');

				var isMultiple = this.parentNode.getAttribute('data-multiple') === 'true';

				if (thisBody.classList.contains('dkt-collapse--open')) {
					this.classList.remove('dkt-collapse--header-open');
					thisBody.classList.remove('dkt-collapse--open');
					thisBody.style.maxHeight = '0';
				} else {
					if (isMultiple === false) {
						[].forEach.call(allCollapse, function(collapse) {
							var collapseBody = collapse.querySelector('.dkt-collapse_body');

							collapse.querySelector('.dkt-collapse_header').classList.remove('dkt-collapse--header-open');
							collapseBody.classList.remove('dkt-collapse--open');
							collapseBody.style.maxHeight = '0';
						});						
					}
					
					this.classList.add('dkt-collapse--header-open');
					thisBody.classList.add('dkt-collapse--open');

					var thisContentHeight = thisBody.querySelector('.dkt-collapse_body-content').offsetHeight;
					thisBody.style.maxHeight = thisContentHeight + 'px';
				}
			});
	}
}

module.exports = moduleCollapse;


// WEBPACK FOOTER //
// ./src/modules-es5/commons/layout/collapse.js